<template>
  <div class="bundlesPage pt-8 mx-auto w-10/12">
    <div class="row grid-margin">
      <div>
        <legend class="bundlesPage__Title">
         Ondertekening succesvol
        </legend>
        <legend class="bundlesPage__details">
         Uw machtiging voor de patiënt is aangemaakt
        </legend>
        <legend v-if="bundles.illnessBundle && bundles.illnessBundle.length > 0" class="bundlesPage__details">
        Wij denken dat de volgende bestelpakketten relevant zijn voor deze patiënt:
        </legend>
        <legend v-else class="bundlesPage__details">
          Voor het uitzoeken en bestellen van producten navigeert u naar de catalogus.
        </legend>
      </div>
    </div>
    <div v-if="bundles.illnessBundle && bundles.illnessBundle.length > 0 && showBundles" class="row grid-margin">
      <v-bundles :bundles="bundles.illnessBundle" />
    </div>
    <div class="row grid-margin border-t-2 border-white" v-if="bundles.illnessBundle && bundles.illnessBundle.length > 0">
        <legend class="bundlesPage__details">
         Voor het uitzoeken en bestellen van producten navigeert u naar de catalogus:
        </legend>
    </div>
    <div class="row grid-margin">
      <v-button tagelement="a" hollow md @click.prevent="$router.push('/patientdashboard')">
        Ga naar dashboard van patiënt
      </v-button>
      <v-button v-if="showCatalog" tagelement="a" primary md @click.prevent="$router.push('/catalog')">
        Naar catalogus
      </v-button>
    </div>
  </div>
</template>

<script>
import VBundles from '@/components/sections/catalog/Bundles';
import axios from 'axios';
import { useStore } from 'vuex';
import router from '@/router';

export default {
  name: 'Bundles',
  components: {
    VBundles
  },
  setup() {
    const store = useStore();
    const siteCode = store.state.navigation.siteCode;

    return {
      siteCode
    };
  },
  data() {
    return {
      bundles: {}
    };
  },
  computed: {
    showBundles() {
      return router.currentRoute.value.params?.treatmentAreaId === '1004';
    },
    showCatalog() {
      return this.siteCode !== 'MIF';
    }
  },
  created() {
    axios.get('Products/GetIllnessBundle').then((response) => {
      if (response && response.data) {
        this.bundles = response.data;
      }
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.bundlesPage {
  a {
    margin: 0px 20px 0px 0px;
  }
  &__Title {
    display: flex;
    font-size: 30px;
    color: $teal-darkest;
    font-weight: 300;
  }
  &__details {
    font-size: 16px;
    color: $gray-darkest;
    margin: 20px 0px 20px 0px;
  }
}
</style>
